import { getFirestore, doc, getDoc } from 'firebase/firestore';

/**
 * Liste des emails administrateurs autorisés
 * ⚠️ IMPORTANT : Modifiez cette liste avec VOTRE email uniquement
 */
const ADMIN_EMAILS = [
  'admin@allure.com', // Email principal admin
  'allure.jtr@gmail.com', // ⭐ Votre email admin
];

/**
 * Vérifie si un utilisateur est administrateur
 * Vérifie d'abord dans Firestore, puis dans la liste des emails autorisés
 * @param userId - L'ID de l'utilisateur Firebase
 * @param userEmail - L'email de l'utilisateur (optionnel, pour vérification de secours)
 * @returns true si l'utilisateur est admin, false sinon
 */
export async function isUserAdmin(userId: string, userEmail?: string): Promise<boolean> {
  try {
    // 1. Vérifier dans Firestore si le statut admin est défini
    const db = getFirestore();
    const userDoc = await getDoc(doc(db, 'users', userId));
    
    if (userDoc.exists()) {
      const userData = userDoc.data();
      // Si le champ isAdmin existe et est true, l'utilisateur est admin
      if (userData?.isAdmin === true) {
        return true;
      }
    }

    // 2. Vérification de secours : vérifier l'email dans la liste autorisée
    if (userEmail && ADMIN_EMAILS.includes(userEmail.toLowerCase())) {
      return true;
    }

    return false;
  } catch (error) {
    console.error('Erreur lors de la vérification du statut admin:', error);
    // En cas d'erreur, ne pas autoriser l'accès
    return false;
  }
}

/**
 * Définit un utilisateur comme administrateur dans Firestore
 * ⚠️ Cette fonction doit être appelée manuellement depuis la console Firebase
 * ou via un script backend sécurisé
 * @param userId - L'ID de l'utilisateur à promouvoir admin
 */
export async function setUserAsAdmin(userId: string): Promise<void> {
  try {
    const db = getFirestore();
    const { updateDoc } = await import('firebase/firestore');
    await updateDoc(doc(db, 'users', userId), {
      isAdmin: true,
      adminSince: new Date()
    });
  } catch (error) {
    console.error('Erreur lors de la promotion admin:', error);
    throw error;
  }
}

